export default "__VITE_ASSET__Cno45CjD__"